import React,{ Suspense, useContext, useState } from "react"
import { useFilters } from "shared-components/Components/Filters/Filters.hook"
import { Modal } from "shared-components/Components/Modal/web"
import { AmenitiesDataOptionsTypes } from "shared-components/ViewFragments/SearchResults/Sider/TopBarFilters/types"
import { useSearchResultsFilters } from "../../Filters/SearchResultsFilters.hook"
import { firstLetterToUppercase } from "src/utils/Functions"
import { ConfigStateContext } from 'shared-components/Contexts/Configurations/context'
import { useFacilities } from "shared-components/Components/Filters/Facilities/Facilities.hook"
import "./styles.less"
import { removeAccents } from "@Utils/Functions"
import { amenities } from "../AmenitiesFilter/amenities"

export type amenitiesTypes = {
    id: number,
    nombre: string,
    grupo: string,
    IDtipos: number,
    IDoperaciones: any
}

export interface FacilitiesModalProps {
	show: boolean,
    setShow: (show: boolean) => void
}

export const AmenitiesModal = ({ show, setShow } : FacilitiesModalProps) => {
    const { filters } = useFilters()
    const { changeFiltersAndUpdateURL: changeFilters } = useSearchResultsFilters()
    const { translations } = useContext(ConfigStateContext)
    const {facilities:{options}} = useFacilities()    
    const [activeTab, setActiveTab] = useState("all")
    const [searchValue, setSearchValue] = useState("")
    const newOptions:AmenitiesDataOptionsTypes[] = (options as amenitiesTypes[])?.map((opt)=>{
        const name = opt.nombre.split('  / ')[0] ?? ''

        return{
            grupo:opt.grupo,
            IDtipos:opt.IDtipos,
            IDoperaciones:opt.IDoperaciones,
            text:name,
            value:opt.id,
            id:opt.id,
        }
    });
    const tourVirtualItem = amenities.find(amenity => amenity.id === 'virtualTour')
    const tourVirtualAsOption: AmenitiesDataOptionsTypes | null = tourVirtualItem ? {
        grupo: tourVirtualItem.grupo,
        IDtipos: tourVirtualItem.IDtipos as any,
        IDoperaciones: tourVirtualItem.IDoperaciones,
        text: tourVirtualItem.nombre,
        value: tourVirtualItem.id,
        id: undefined,
        icon: () => Promise.resolve({ default: tourVirtualItem.icon }),
    } : null
    const allOptions: AmenitiesDataOptionsTypes[] = [
        ...(newOptions || []),
        ...(tourVirtualAsOption ? [tourVirtualAsOption] : []),
    ]
    const uniqueGroups = [...new Set(allOptions.map(item => item.grupo))].filter(group => group)

    const filteredAmenities = activeTab === "all"
        ? allOptions.filter(item => removeAccents(item.text.toLowerCase()).includes(removeAccents(searchValue.toLowerCase())))
        : allOptions.filter(item => item.grupo === activeTab && removeAccents(item.text.toLowerCase()).includes(removeAccents(searchValue.toLowerCase())));

    const watchCheckedInFilter = (filterTypeObj, filterType) => {
        return filterTypeObj ? filterTypeObj.map((val) => ({ ...val, value: val.value, text: val.text, checked: filterType?.includes(val.value) })) : []
    }

    const handleAmenities = (value) => {
        if (value === 'virtualTour') {
            changeFilters({ tour3d: filters.tour3d ? null : { value: true, text: 'Tour Virtual 3D' } })
            return
        }
        if (amenitiesList.length) {
            let newOptions = amenitiesList?.map((item) =>
                item.value == value ? { ...item, checked: !item.checked } : item
            );

            let newFilters = newOptions
                .filter((v) => v.checked && v.value !== 'virtualTour')
                .map((e) => ({ value: e.value, text: `con ${e.text}` }));
            changeFilters({ facilitiesGroup: newFilters });
        }
    }

    const amenitiesList: AmenitiesDataOptionsTypes[] = watchCheckedInFilter(allOptions, filters?.facilitiesGroup)
        .map(item => item.value === 'virtualTour' ? { ...item, checked: !!filters.tour3d } : item)

    return (
        <Modal
            show={show}
            width="800px"
            title='Selecciona una o varias características'
            onClose={() =>{
                setSearchValue('')
                setActiveTab('all')
                setShow(false)                    
            }}
        >
            <div>
                <input
                    type="text"
                    placeholder={`${firstLetterToUppercase(translations.busca)} por palabra`}
                    className="search-amenities"
                    onChange={(e) => setSearchValue(e.target.value)}
                />

                <ul className="nav-amentities nav-tabs">
                    <li
                        className={`nav-item ${activeTab === "all" ? "active" : ""}`}
                        onClick={() => setActiveTab("all")}
                    >
                        Todos
                    </li>
                    {uniqueGroups.map(group => {
                        const counter = allOptions.filter(item => {
                            if (item.grupo !== group) return false
                            if (item.value === 'virtualTour') return !!filters.tour3d
                            return filters.facilitiesGroup?.includes(Number(item.value))
                        }).length
                        
                        return (
                            <li
                                key={group}
                                className={`nav-item ${activeTab === group ? "active" : ""}`}
                                onClick={() => setActiveTab(group)}
                            >
                                {counter > 0 &&
                                    <div className="counter">
                                        {counter}
                                    </div>
                                }

                                {group}
                            </li>
                        )
                    })}
                </ul>

                <div className="amenities-container-modal">
                    {amenitiesList && filteredAmenities.map((val, i) => {
                        return (
                            <div
                                key={'ameneties-' + i}
                                className={"pill " + ((val.value === 'virtualTour' ? !!filters.tour3d : filters.facilitiesGroup?.includes(val.value as number)) ? 'active' : '')}
                                onClick={() => handleAmenities(val.value)}
                            >
                                {val.icon?<Suspense fallback={<div>...</div>}>
                                    {React.createElement(React.lazy(val.icon))}
                                </Suspense>:<></>}
                                <span className="text">{val.text}</span>
                            </div>
                        )
                    })}
                </div>
            </div>
        </Modal>
    )
}